import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../icon';
import Input from './Input';

class Button extends Input {
  static propTypes = {
    iconSize: PropTypes.oneOf(['', 'medium']),
    anchorLabel: PropTypes.string,
  }
  static defaultProps = {
    iconSize: null,
    anchorLabel: null,
  }
  render() {
    return (
      <a
        className="c-btn c-btn--blank c-btn--link u-p0"
        {...this.getInputProps()}
        ref={(ref) => { this.el = ref; }}
      >
        <Icon glyph={GLYPHS.plus} size="medium" />
        <span
          className="c-btn__text"
        >
          {this.props.anchorLabel}
        </span>
      </a>
    );
  }
}

export default Button;
